import { HStack as NbHStack } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const HStack = NbHStack;

export default addWithConfig(HStack);
